import {styled} from 'styled-components'

export const StyledTimeInput = styled.div`
    width: 108px;
    & > * {
        width: 100%;
    }
`
